module.exports = __webpack_public_path__ + "static/assets/2a656db1a95b5f65f65cddc365faa043.png";